// extracted by mini-css-extract-plugin
export default {"bottom-links__list":"GfqCY","bottom-links__link":"rAPnp","bottom-links":"dV7g7","stores":"WRaKt","stores__title":"eUwx2"};